import { isHicampus } from './is-hicampus'

// https://docs.google.com/spreadsheets/d/1Z3LH-hzo37fGRMSkHrOTfBQC8lnt_N0b-3yizfSFx4I/edit#gid=0
// https://docs.google.com/spreadsheets/d/1UJe8BqquNyHfucJFz8hoEJ-zzOPeYOa8cSY2HYqj_q4/edit?gid=0#gid=0
export const URL_TITLE_MAP = {
	// '/login'
	LOGIN: isHicampus ? '하이캠퍼스 종합학습플랜 - 로그인' : '브릿지 프로젝트 - 로그인',
	// '/auth/agreement'
	AUTH_AGREEMENT: isHicampus ? '하이캠퍼스 종합학습플랜' : '브릿지 프로젝트',
	// '/comprehensive-learning-diagnosis/'
	COMPREHENSIVE_LEARNING_DIAGNOSTICS: isHicampus ? '하이캠퍼스 종합학습플랜 - 종합학습진단' : '브릿지 프로젝트 - 종합학습진단',
	// '/premium-1on1-consulting-service/'
	ONE_ON_ONE_CONSULTING: isHicampus ? '하이캠퍼스 종합학습플랜 - 1:1 공부 컨설팅' : '브릿지 프로젝트 - 1:1 공부 컨설팅',
	// '/all-care-pack/'
	ALL_CARE_PACK: isHicampus ? '하이캠퍼스 종합학습플랜 - 1:1 All Care Pack' : '브릿지 프로젝트 - 1:1 All Care Pack',
	// '/pricing/'
	PRICING: isHicampus ? '하이캠퍼스 종합학습플랜 - 상품안내' : '브릿지 프로젝트 - 상품안내',
	// '/promotion/whitepencil/'
	PROMOTION_WHITE_PENCIL: isHicampus ? '하이캠퍼스 종합학습플랜 - 화이트 펜슬 제휴' : '브릿지 프로젝트 - 화이트 펜슬 제휴',
	// '/event/'
	EVENT: isHicampus ? '하이캠퍼스 종합학습플랜 - 이벤트' : '브릿지 프로젝트 - 이벤트',
	// '/tab-bar/?path=home'
	HOME: isHicampus ? '하이캠퍼스 종합학습플랜 - 학습홈' : '브릿지 프로젝트 - 학습홈',
	// '/tab-bar/?path=calendar'
	CALENDAR: '홈 - 공부 달력',
	// '/tab-bar/?path=report'
	REPORT: '홈 - 리포트',
	// '/tab-bar/?path=my-page'
	MY_PAGE: isHicampus ? '하이캠퍼스 종합학습플랜 - 마이페이지' : '홈 - 마이페이지',
	// '/?path=diagnosticResult'
	HOME_DIAGNOSTIC_RESULT: isHicampus ? '하이캠퍼스 종합학습플랜 - 학습 전략 진단 내역' : '홈 - 학습 전략 진단 내역',
	// '/?path=consulting'
	HOME_CONSULTING: isHicampus ? '하이캠퍼스 종합학습플랜 - 컨설팅 내역' : '홈 - 컨설팅 내역',
	// '/calendar/study-plan/?date='
	CALENDAR_STUDY_PLAN: '공부 달력 - 공부 계획',
	// '/calendar/study-plan/guide'
	CALENDAR_STUDY_PLAN_GUIDE: '공부 달력 - 공부 계획 - 가이드',
	// '/calendar/study-plan-detail/?planId='
	STUDY_PLAN_DETAIL: '공부 달력 - 공부 계획 상세',
	// '/report/detail/daily/?id='
	REPORT_DAILY: '리포트 - 일간 리포트',
	// '/report/detail/weekly/?id='
	REPORT_WEEKLY: '리포트 - 주간 리포트',
	// '/diagnostic/diagnostic-list'
	DIAGNOSTIC_LIST: isHicampus ? '하이캠퍼스 종합학습플랜 - 학습 전략 진단 내역' : '마이페이지 - 종합학습진단 내역',
	// '/diagnostic/test/?diagnosticSheetId='
	DIAGNOSTIC_TEST: isHicampus ? '하이캠퍼스 종합학습플랜 - 학습 전략 진단 응시' : '종합학습진단 응시',
	// '/diagnostic/?resetDiagnosticSheetId='
	DIAGNOSTIC: isHicampus ? '하이캠퍼스 종합학습플랜 - 학습 전략 진단 응시' : '종합학습진단 응시',
	// '/diagnostic/result/?diagnosticSheetId='
	DIAGNOSTIC_RESULT: isHicampus ? '하이캠퍼스 종합학습플랜 - 학습 전략 진단 결과' : '종합학습진단 결과',
	// '/my-page/parent-connection/'
	MY_PAGE_PARENT_CONNECTION: '마이페이지 - 부모님 연결',
	// '/my-page/study-profile/?isStudent=true'
	MY_PAGE_STUDY_PROFILE: '마이페이지 - 공부현황 점검',
	// '/diagnostic/diagnostic-list/'
	MY_PAGE_DIAGNOSTICS: isHicampus ? '하이캠퍼스 종합학습플랜 - 학습 전략 진단 내역' : '마이페이지 - 종합학습진단 내역',
	// '/consulting/reservation/book'
	CONSULTING_RESERVATION_BOOK: isHicampus ? '하이캠퍼스 종합학습플랜 - 컨설팅 예약' : '마이페이지 - 컨설팅 예약',
	// '/consulting/reservations/'
	MY_PAGE_CONSULTING_RESERVATIONS: isHicampus ? '하이캠퍼스 종합학습플랜 - 컨설팅 내역' : '마이페이지 - 컨설팅 내역',
	// '/consulting/reservations/change/?id='
	CONSULTING_CHANGE_RESERVATION: isHicampus ? '하이캠퍼스 종합학습플랜 - 컨설팅 변경' : '마이페이지 - 컨설팅 변경',
	// '/consulting/reservations/detail/?id='
	MY_PAGE_CONSULTING_RESERVATIONS_DETAIL: isHicampus ? '하이캠퍼스 종합학습플랜 - 컨설팅 예약 상세' : '마이페이지 - 컨설팅 예약 상세',
	// '/special-lecture/'
	MY_PAGE_SPECIAL_LECTURE: '마이페이지 - 일깨움 특강',
	// '/my-page/setting/'
	MY_PAGE_SETTING: '마이페이지 - 설정',
	// '/billing/payment-history/'
	MY_PAGE_BILLING_PAYMENTS: '마이페이지 - 결제 내역',
	// '/billing/payment-details/?merchantUid'
	MY_PAGE_BILLING_PAYMENT_DETAILS: '결제 내역 - 결제 상세',
	// '/billing/manage-payment/'
	MY_PAGE_BILLING_MANAGE_PAYMENT: '마이페이지 - 결제 수단 관리',
	// '/billing/register-card/?beforeScreen=manage-payment&isChanged=false'
	MY_PAGE_BILLING_REGISTER_CARD: '결제 수단 관리 - 카드 등록',
	// '/my-page/register-coupon/'
	MY_PAGE_REGISTER_COUPON: '마이페이지 - 코드 등록',
	// '/my-page/inquiry/'
	MY_PAGE_INQUIRY: '마이페이지 - 1:1 문의',
	// '/my-page/request-inquiry/'
	MY_PAGE_REQUEST_INQUIRY: '1:1 문의 - 문의하기',
	// '/my-page/inquiry-detail/?inquiryId='
	MY_PAGE_INQUIRY_DETAIL: '1:1 문의 - 문의 내용',
}
